// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cui-input-group-outline:has(.input-group-addon):focus-within {\n  outline: 2px solid var(--border-focused);\n  outline-offset: 1px;\n}\n\n.cui-input-group-outline:has(.input-group-addon) input:focus {\n  outline: none;\n}", ""]);
// Exports
module.exports = exports;
